var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component images",attrs:{"data-count":_vm.data.content.length}},_vm._l((_vm.data.content),function(image,key){return _c('ImageBlock',{key:key,attrs:{"data-type":'multiple',"data":image,"hasScale":false}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }